import {useMutation} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {ApiResult} from "../../../../types/ApiResult";

export const useConfirmOrder = (quoteID: number, poNumber: string, poAmount: number) => {

    const {mutateAsync, isLoading} = useMutation({
        mutationFn: async () => {
            return await apiClient.post('/estimate/confirm-order', {
                quoteID,
                poNumber,
                poAmount
            }) as ApiResult;
        }
    });

    return {
        mutateAsync, isLoading
    }
}
